import _ from 'lodash';
import { MuiInputText, MuiSelectItem, MuiAutocomplete, MuiForm, MuiButtonFlat, MuiButtonLink, MuiInputLocation, MuiCardAlert, MuiAlgoliaAutocomplete } from '@ubeeqo/motion-ui';
import { INITIAL_STATUS as INITIAL_STATUS$1, KEYCODE, logger } from '@ubeeqo/web-utils';
import { external } from '@ubeeqo/web-api-client';

var renderValidComponent = {
  data() {
    return {
      hasValidPropsToBeRendered: false,
    };
  },

  created() {
    this.checkValidPropsToBeRendered();
  },

  methods: {
    checkValidPropsToBeRendered() {
      const props = _.keys(_.get(this, '$options.props', {}));

      this.$data.hasValidPropsToBeRendered = props.every((key) => {
        const configuration = _.get(this, `$options.props.${key}`);

        if (!_.has(configuration, 'validator')) {
          return true;
        }

        return configuration.validator(_.get(this, `$props.${key}`));
      });
    },
  },
};

var PROFILES = Object.freeze({
  personal: 'personal',
  business: 'business',
});

var COMPONENT_EVENTS = {
  change: 'change',
  input: 'input',
  updateForm: 'update-form',
  remove: 'remove',
  selectedResult: 'selected-result',
};

var INITIAL_STATUS = Object.freeze({
  idle: 'IDLE',
  loading: 'LOADING',
  loaded: 'LOADED',
  error: 'ERROR',
});

var COST_ALLOCATION_INPUT_TYPE = {
  select: 'select',
  text: 'text'
};

var costAllocationType = {
  profile: 'profile',
  booking: 'booking'
};

const requiredItemProps = [
  'name',
  'code',
  'required',
  'children',
  'input_type',
];

const requiredValueProps = [
  'name',
  'code',
  'required',
  'children',
  'input_type',
];

var CostAllocationFormItemComponent = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasValidPropsToBeRendered)?_c('div',{class:[
    'CostAllocationFormItemComponent',
    ("CostAllocationFormItemComponent--" + (_vm._.get(_vm.item, 'input_type'))) ]},[(_vm.IS_SELECT_INPUT_TYPE)?[_c('MuiAutocomplete',_vm._b({on:{"change":function (child) { return _vm.$emit(_vm.EVENTS.change, child); }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v;},expression:"value"}},'MuiAutocomplete',_vm.muiAutocompleteProps,false),_vm._l((_vm._.get(_vm.item, 'children', [])),function(child,index){return _c('MuiSelectItem',{key:("CostAllocationFormItemComponent" + index),attrs:{"value":child,"title":_vm._.get(child, 'code')}})}),1)]:_vm._e(),_vm._v(" "),(_vm.IS_TEXT_INPUT_TYPE)?[_c('MuiInputText',_vm._b({on:{"change":function (text) { return _vm.$emit(_vm.EVENTS.change, Object.assign({}, _vm.item, _vm.value, {code: text})); }}},'MuiInputText',_vm.muiInputTextProps,false))]:_vm._e()],2):_vm._e()},
staticRenderFns: [],
  name: 'CostAllocationFormItemComponent',

  components: {
    MuiInputText,
    MuiSelectItem,
    MuiAutocomplete,
  },

  mixins: [
    renderValidComponent,
  ],

  props: {
    value: {
      required: true,
      default: () => null,
      // eslint-disable-next-line no-prototype-builtins
      validator: (formItemValue) => {
        // Checking the props of the object. We need a specific object structure.
        const isValidObject = _.isObject(formItemValue) && requiredValueProps.every(prop => _.has(formItemValue, prop));

        // "formItemValue" will be Nil when user has not selected a value for that item
        return _.isNil(formItemValue) || isValidObject;
      },
    },
    item: {
      required: true,
      default: () => null,
      // eslint-disable-next-line no-prototype-builtins
      validator: (formItem) => {
        // Checking the props of the object. We need a specific object structure.
        const isValidObject = _.isObject(formItem) && requiredItemProps.every(prop => _.has(formItem, prop));

        // "formItemItem" will be Nil when we have not a list of Cost allocation
        return _.isNil(formItem) || isValidObject;
      },
    },
    text: {
      required: true,
      type: Object,
    },
  },

  computed: {
    muiInputTextProps() {
      return {
        name: _.get(this.item, 'name'),
        label: _.get(this.item, 'name'),
        placeholder: _.get(this.item, 'name'),
        required: _.get(this.item, 'required'),
        value: _.get(this.value, 'code', ''),
        pattern: !_.get(this.item, 'required') ? [] : this.getInputTextPatterns(),
        customErrorMessages: {
          empty: _.get(this.text, 'errors.mandatory', 'This field is mandatory'),
        },
        optionalText: '',
        fullWidth: true,
      };
    },
    muiAutocompleteProps() {
      return {
        name: _.get(this.item, 'name'),
        label: _.get(this.item, 'name'),
        placeholder: _.get(this.item, 'name'),
        required: _.get(this.item, 'required'),
        objectLabel: 'code',
        optionalText: '',
        fullWidth: true,
        returnObject: true,
      };
    },
  },

  watch: {
    value() {
      this.checkValidPropsToBeRendered();
    },
    item() {
      this.checkValidPropsToBeRendered();
    },
  },

  created() {
    this._ = _;
    this.EVENTS = COMPONENT_EVENTS;
    this.IS_TEXT_INPUT_TYPE = _.get(this, '$props.item.input_type') === COST_ALLOCATION_INPUT_TYPE.text;
    this.IS_SELECT_INPUT_TYPE = _.get(this, '$props.item.input_type') === COST_ALLOCATION_INPUT_TYPE.select;
  },

  methods: {
    getInputTextPatterns() {
      return [
        {
          rule: /\S+/,
          message: _.get(this.text, 'errors.mandatory', 'This field is mandatory'),
        },
      ];
    },
  },
};

var CostAllocationFormComponent = {
render: function(){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MuiForm',_vm._g({ref:"MuiForm",staticClass:"CostAllocationFormComponent",attrs:{"model":_vm.form,"validate-on-load":false}},( _obj = {}, _obj[_vm.EVENTS.change] = function (value) { return _vm.$emit(_vm.EVENTS.updateForm, value); }, _obj )),[(_vm._.isArray(_vm.items) && _vm.items.length)?[_vm._l((_vm.items),function(item,index){
  var _obj;
return _c('CostAllocationFormItemComponent',_vm._g({key:("CostAllocationFormItemComponent" + index),attrs:{"value":_vm.findValue(_vm.value, item.uuid),"item":item,"text":_vm.text}},( _obj = {}, _obj[_vm.EVENTS.change] = function (childSelected) { return _vm.$emit(_vm.EVENTS.input, _vm.replaceValue(item, childSelected, _vm.value)); }, _obj )))}),_vm._v(" "),(_vm.acceptButton)?_c('MuiButtonFlat',{attrs:{"disabled":_vm.acceptButtonProps.isDisabled,"is-loading":_vm.acceptButtonProps.isLoading},nativeOn:{"click":function($event){return _vm.acceptButtonProps.onClick($event)}}},[_vm._v("\n      "+_vm._s(_vm.acceptButtonProps.text)+"\n    ")]):_vm._e()]:[_vm._t("empty",[_vm._v("\n      No items\n    ")])]],2)},
staticRenderFns: [],
  name: 'CostAllocationFormComponent',
  components: {
    MuiForm,
    MuiButtonFlat,
    CostAllocationFormItemComponent,
  },

  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    acceptButton: {
      type: Object,
      default: () => null,
    },
    text: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    acceptButtonProps() {
      return _.assign({
        text: 'OK',
        isDisabled: false,
        onClick: () => {},
        isLoading: false,
      }, _.get(this, '$props.acceptButton', {}));
    },
  },

  created() {
    this._ = _;
    this.EVENTS = COMPONENT_EVENTS;
  },

  methods: {
    findValue(list, itemUuid) {
      const selectedValueFromItem = _.find(list, { uuid: itemUuid });

      return _.get(selectedValueFromItem, 'children.0');
    },
    replaceValue(item = {}, childSelected = {}, list = []) {
      // eslint-disable-next-line no-param-reassign
      list = _.isArray(list) ? list : [];

      const itemFoundInList = _.find(list, { uuid: item.uuid });
      if (itemFoundInList) {
        return this.replaceValueWhenItChanges(item.uuid, childSelected, list);
      }

      return this.addNewValue(item, childSelected, list);
    },
    replaceValueWhenItChanges(itemUuid, childSelected, list = []) {
      const costAllocation = _.find(list, { uuid: itemUuid });
      _.set(costAllocation, 'children.0', childSelected);
      return list;
    },
    addNewValue(item = {}, childSelected = {}, list = []) {
      list.push({ ...item, children: [childSelected] });
      return list;
    },
  },
};

const NAMESPACE = 'COST_ALLOCATION_DATA';

const state = () => ({
  STATUS: {
    ...INITIAL_STATUS$1,
  },
  currentCostAllocations: null,
  costAllocationList: null,
});

const GETTERS = {
  API_PAYLOAD_CURRENT_COST_ALLOCATION: 'API_PAYLOAD_CURRENT_COST_ALLOCATION',
};

const getters = {
  [GETTERS.API_PAYLOAD_CURRENT_COST_ALLOCATION](state) {
    if (!_.isArray(state.currentCostAllocations)) {
      return [];
    }

    const payload = _.map(state.currentCostAllocations, (costAllocation) => {
      const parentUuid = _.get(costAllocation, 'uuid', '');

      const type = _.get(costAllocation, 'input_type', 'select');

      let value = null;
      switch (type) {
        case COST_ALLOCATION_INPUT_TYPE.text:
          value = _.trim(_.get(costAllocation, 'children.0.code', null));
          break;
        case COST_ALLOCATION_INPUT_TYPE.select:
          value = _.get(costAllocation, 'children.0.uuid', null);
          break;
        default:
          break;
      }

      if (!(parentUuid && type && value)) {
        return null;
      }

      return {
        parent_uuid: parentUuid,
        type,
        value,
      };
    })
      .filter(item => item);

    return payload;
  },
};

const MUTATIONS = {
  setStatus: 'SET_STATUS',
  setCurrentCostAllcation: 'SET_CURRENT_COST_ALLOCATION',
  setCostAllocationList: 'SET_COST_ALLOCATION_LIST',
};

const mutations = {
  [MUTATIONS.setStatus](state, payload) {
    const states = _.keys(state.STATUS);

    if (_.includes(states, payload)) {
      _.each(states, (key) => {
        state.STATUS[key] = key === payload;
      });
    }
  },
  [MUTATIONS.setCurrentCostAllcation](state, payload) {
    state.currentCostAllocations = payload;
  },
  [MUTATIONS.setCostAllocationList](state, payload) {
    state.costAllocationList = payload;
  },
};

var CostAllocationDataModule = {
  store: {
    state,
    mutations,
    getters,
  },
  NAMESPACE,
  GETTERS,
  MUTATIONS,
};

var labels = {
  inputPlaceholder: 'Add passengers',
  addButtonText: 'Add'
};

var AdditionalPassengersComponent = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdditionalPassengersComponent position-relative"},[_c('MuiInputText',{staticClass:"w-100",attrs:{"placeholder":_vm.mergedLabels.inputPlaceholder,"disabled":_vm.disabled,"on-focus":_vm.onFocusInputText,"on-blur":_vm.onBlurInputText,"on-change":function () {},"name":"additionalPassengers","icon-position":"left","input-class":"AdditionalPassengersComponent__input"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v;},expression:"text"}},[_c('template',{slot:"icon"},[_c('span',{staticClass:"icons-passenger color-ink-light font-xl"})])],2),_vm._v(" "),_c('MuiButtonLink',{staticClass:"\n      AdditionalPassengersComponent__button\n      position-absolute\n      mw-100\n    ",attrs:{"uppercase":false,"square":""},nativeOn:{"click":function($event){return _vm.onClickAddItem($event)}}},[_vm._v("\n    "+_vm._s(_vm.mergedLabels.addButtonText)+"\n  ")])],1)},
staticRenderFns: [],
  name: 'AdditionalPassengersComponent',

  components: {
    MuiInputText,
    MuiButtonLink,
  },

  props: {
    labels: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      text: null,
      focused: false,
    };
  },

  computed: {
    mergedLabels() {
      return _.merge({}, labels, _.get(this, '$props.labels'));
    },
  },

  mounted() {
    window.addEventListener('keyup', this.onKeyUpEnterToAddItem);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onKeyUpEnterToAddItem);
  },

  methods: {
    emitInput(values) {
      this.$emit('input', values);
    },

    cleanText() {
      this.$data.text = '';
    },

    onClickAddItem() {
      const text = _.trim(this.$data.text);

      if (_.isEmpty(text)) {
        return;
      }

      this.cleanText();

      this.$nextTick(() => {
        this.emitInput(text);
      });
    },

    onKeyUpEnterToAddItem($event) {
      if (!this.focused) {
        return;
      }

      if ($event.keyCode === KEYCODE.ENTER) {
        this.onClickAddItem();
      }
    },

    onFocusInputText() {
      this.focused = true;
    },

    onBlurInputText() {
      this.focused = false;
    },
  },
};

var UserBadgeComponent = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'mui-badge',
    'mw-100',
    'd-inline-flex justify-content-center align-items-center',
    ("v1-background-color-" + _vm.bgColor)
  ]},[_c('span',{staticClass:"mr-1 v1-color-ink text-ellipsis"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._v(" "),(_vm.removeable)?_c('span',{staticClass:"icons-remove-filled cursor-pointer color-ink-light",on:{"click":function($event){return _vm.$emit(_vm.EVENTS.remove)}}}):_vm._e()])},
staticRenderFns: [],
  name: 'UserBadgeComponent',

  props: {
    text: {
      type: String,
      required: true,
    },

    removeable: {
      type: Boolean,
      default: true,
    },

    bgColor: {
      type: String,
      default: 'corporate-secondary-lightest',
    },
  },

  created() {
    this.EVENTS = COMPONENT_EVENTS;
  },
};

var VEHICLE_USER = 'VEHICLE_USER';
var PREFERRED_LOCATIONS = 'PREFERRED_LOCATIONS';

var MUTATIONS$1 = {
  add: 'ADD',
  remove: 'REMOVE',
  removeAll: 'REMOVE_ALL',
  setStatus: 'SET_STATUS',
  setInvalidDrivers: 'SET_INVALID_DRIVERS'
};

var GETTERS$1 = {
  data: 'DATA',
  count: 'COUNT',
  isInvalidDriver: 'IS_INVALID_DRIVER'
};

var ACTIONS = {
  validateDrivers: 'VALIDATE_DRIVERS_EMAILS',
  updateDrivers: 'UPDATE_DRIVERS'
};

const state$1 = () => ({
  data: [],
  status: { ...INITIAL_STATUS$1 },
  invalidDrivers: [],
});

const getters$1 = {
  [GETTERS$1.data](state) {
    return (filter = {}) => _.filter(state.data, filter);
  },

  [GETTERS$1.count](state, getter) {
    return (filter = {}) => _.size(_.get(getter, GETTERS$1.data, () => [])(filter));
  },

  [GETTERS$1.isInvalidDriver](state) {
    return email => _.includes(state.invalidDrivers, email);
  },
};

const mutations$1 = {
  [MUTATIONS$1.add](state, { id, type, data }) {
    state.data = [...state.data, { id, type, data }];
  },

  [MUTATIONS$1.remove](state, payload) {
    const vehicleUsers = state.data;
    _.remove(vehicleUsers, payload);
    state.data = [...vehicleUsers];
  },

  [MUTATIONS$1.removeAll](state) {
    state.data = [];
  },

  [MUTATIONS$1.setStatus](state, payload) {
    if (_.has(state.status, payload)) {
      _.each(state.status, (value, key) => {
        state.status[key] = key === payload;
      });
    }
  },

  [MUTATIONS$1.setInvalidDrivers](state, payload) {
    if (_.isArray(payload)) {
      state.invalidDrivers = payload;
    }
  },
};

const actions = {
  [ACTIONS.validateDrivers]({ commit }, { companyUuid, emails }) {
    commit(MUTATIONS$1.setStatus, INITIAL_STATUS.loading);

    return external.userCompanyAccount.postCheckCompanyEmails(companyUuid, { emails })
      .then((response) => {
        const validatedDrivers = response || [];

        const invalidDrivers = _.compact(_.map(emails, (email) => {
          const { valid } = _.find(validatedDrivers, { email });
          return !valid ? email : null;
        }));

        commit(MUTATIONS$1.setInvalidDrivers, invalidDrivers);
        commit(MUTATIONS$1.setStatus, INITIAL_STATUS.loaded);
      })
      .catch((error) => {
        commit(MUTATIONS$1.setStatus, INITIAL_STATUS.error);
        throw error;
      });
  },

  [ACTIONS.updateDrivers]({ commit }, { bookingUuid, emails }) {
    commit(MUTATIONS$1.setStatus, INITIAL_STATUS.loading);

    return external.booking.postAdditionalDrivers(bookingUuid, { emails })
      .then(() => {
        commit(MUTATIONS$1.setStatus, INITIAL_STATUS.loaded);
      })
      .catch((error) => {
        commit(MUTATIONS$1.setStatus, INITIAL_STATUS.error);
        throw error;
      });
  },
};

var VehicleUserModule = {
  store: {
    namespaced: true,
    state: state$1,
    getters: getters$1,
    mutations: mutations$1,
    actions,
  },
  NAMESPACE: VEHICLE_USER,
  MUTATIONS: MUTATIONS$1,
  GETTERS: GETTERS$1,
  ACTIONS,
};

var MUTATIONS$2 = {
  get: 'GET',
  add: 'ADD',
  remove: 'REMOVE',
  setStatus: 'SET_STATUS',
  address: 'ADDRESS'
};

var ACTIONS$1 = {
  postPreferredLocation: 'postPreferredLocation',
  getPreferredLocations: 'getPreferredLocations',
  deletePreferredLocation: 'deletePreferredLocation'
};

const STATUS_DEFAULT = {
  IDLE: true,
  ERROR: false,
  LOADING: false,
  LOADED: false,
};

const DEFAULT_DATA = {
  custom: {
    address_street: '',
  },
  home: {
    address_street: '',
  },
  work: {
    address_street: '',
  },
};

const state$2 = () => ({
  data: { ...DEFAULT_DATA },
  STATUS: { ...STATUS_DEFAULT },
});

const mutations$2 = {
  [MUTATIONS$2.get](state, payload) {
    _.forEach(payload, (value) => {
      state.data[value.type] = value;
    });
  },
  [MUTATIONS$2.add](state, payload) {
    state.data[payload.type] = payload.data;
  },
  [MUTATIONS$2.remove](state, type) {
    _.remove(state.data, { type });
    state.data[type] = {
      address_street: '',
    };
  },
  [MUTATIONS$2.setStatus](state, value) {
    const states = _.keys(state.STATUS);
    if (_.includes(states, value)) {
      states.forEach((key) => {
        state.STATUS[key] = (key === value);
      });
    }
  },
  [MUTATIONS$2.address](state, data) {
    state.data[data.type].address = data.address;
  },
};

const actions$1 = {
  async [ACTIONS$1.postPreferredLocation]({ commit, rootState, state }, type) {
    try {
      const obj = {
        type,
        address: state.data[type].address.address,
        alias: type,
      };
      const IdpUuid = _.get(rootState, 'App.UserAccount.data.uuid');
      const data = await external.userCompanyUserFavouriteLocations.postFavouriteLocation(IdpUuid, obj);
      if (data) commit(MUTATIONS$2.add, { data, type });
    } catch (error) {
      commit(MUTATIONS$2.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
  async [ACTIONS$1.getPreferredLocations]({ commit }, userUuid) {
    try {
      const data = await external.userCompanyUserFavouriteLocations.getFavouriteLocations(userUuid);
      if (data) {
        commit(MUTATIONS$2.get, data);
      }
      commit(MUTATIONS$2.setStatus, 'LOADED');
    } catch (error) {
      commit(MUTATIONS$2.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
  async [ACTIONS$1.deletePreferredLocation]({ commit }, data) {
    try {
      await external.userCompanyUserFavouriteLocations.deleteFavouriteLocation(data.uuid);
      commit(MUTATIONS$2.remove, data.type);
    } catch (error) {
      commit(MUTATIONS$2.setStatus, 'ERROR');
      logger.message(error.message);
    }
  },
};

var PreferredLocationsModule = {
  store: {
    namespaced: true,
    state: state$2,
    mutations: mutations$2,
    actions: actions$1,
  },
  NAMESPACE: PREFERRED_LOCATIONS,
  MUTATIONS: MUTATIONS$2,
  ACTIONS: ACTIONS$1,
};

var defaultLabels = {
  addButtonText: 'Add',
  home: 'Home',
  work: 'Work',
  custom: 'Custom'
};

var PreferredLocationsComponent = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PreferredLocationsComponent"},_vm._l((_vm.data),function(location,type){return _c('div',{key:type,staticClass:"my-3"},[(_vm.gmapApi)?_c('MuiInputLocation',{ref:type,refInFor:true,attrs:{"required-address-components":_vm.addressComponents,"label":_vm.mergedLabels[type],"value":location.address_street,"google":_vm.gmapApi,"placeholder":_vm.mergedLabels[type],"name":type,"full-width":"","size":"m"},on:{"change":function (value) { return _vm.changeAddress(value, type); }}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('MuiButtonFlat',{attrs:{"uppercase":false,"size":"s"},nativeOn:{"click":function($event){return _vm.addNewLocation(type, location.uuid)}}},[_vm._v("\n        "+_vm._s(_vm.mergedLabels.addButtonText)+"\n      ")]),_vm._v(" "),_c('MuiButtonFlat',{attrs:{"square":"","size":"s"},nativeOn:{"click":function($event){return _vm.deleteLocation(location.uuid, type)}}},[_c('div',{staticClass:"icons-cross font-xs",attrs:{"slot":"icon"},slot:"icon"})])],1)],1)}),0)},
staticRenderFns: [],
  name: 'PreferredLocationsComponent',

  components: {
    MuiInputLocation,
    MuiButtonFlat,
  },

  props: {
    labels: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    gmapApi: {
      type: Object,
      default: () => ({}),
    },
    change: {
      type: Function,
      default: undefined,
    },
    update: {
      type: Function,
      default: undefined,
    },
    delete: {
      type: Function,
      default: undefined,
    },
  },

  computed: {

    mergedLabels() {
      return _.merge({}, defaultLabels, _.get(this, this.labels));
    },
    addressComponents() {
      return [
        'route',
        'locality',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'postal_code',
        'country_code',
      ];
    },
  },

  methods: {
    addNewLocation(type, uuid) {
      if (uuid) {
        this.delete({ uuid, type });
      }
      this.update(type);
    },
    deleteLocation(uuid, type) {
      this.delete({ uuid, type });
      _.set(this, `$refs.${type}.0.$refs.inputLocation.value`, '');
      _.set(this, `$refs.${type}.0.address`, '');
    },
    changeAddress(address, type) {
      this.change({ address, type });
    },
  },
};

var VEHICLE_USER_TYPES = {
  passenger: 'PASSENGER',
  driver: 'DRIVER',
  carpooling: 'CARPOOLING'
};
var VEHICLE_USER_ID = {
  bookingSummary: 'BOOKING_SUMMARY'
};

var labels$1 = {
  selectLabel: 'Please enter the email of the person you would like to add as a driver:',
  selectPlaceholder: 'Add drivers',
  infoText: 'Remember you can only add registered users from your company',
  customError: ''
};

var AdditionalDriversComponent = {
render: function(){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdditionalDriversComponent"},[_c('MuiAlgoliaAutocomplete',_vm._g(_vm._b({ref:"muiAlgoliaAutocomplete"},'MuiAlgoliaAutocomplete',_vm.muiAlgoliaAutocompleteProps,false),( _obj = {}, _obj[_vm.EVENTS.selectedResult] = _vm.onSelectOption, _obj ))),_vm._v(" "),(_vm.mergedLabels.customError)?_c('div',{staticClass:"input-error-message font-xs mb-2"},[_vm._v("\n    "+_vm._s(_vm.mergedLabels.customError)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.mergedLabels.infoText)?_c('MuiCardAlert',{attrs:{"type":"alert","full-width":""}},[_c('div',{staticClass:"d-flex align-items-center v1-background-color-warning-lightest"},[_c('i',{staticClass:"\n          AdditionalDriversComponent__icon\n          d-flex justify-content-center align-items-center\n          icons-alert-alone\n          v1-background-color-warning v1-color-white\n          circle\n        ",staticStyle:{"width":"20px","min-width":"20px","height":"20px","min-height":"20px"}}),_vm._v(" "),_c('span',{staticClass:"ml-2 font-s font-normal"},[_vm._v("\n        "+_vm._s(_vm.mergedLabels.infoText)+"\n      ")])])]):_vm._e()],1)},
staticRenderFns: [],
  name: 'AdditionalDriversComponent',

  components: {
    MuiCardAlert,
    MuiAlgoliaAutocomplete,
  },

  props: {
    labels: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    algoliaIndex: {
      type: String,
      required: true,
    },
    algoliaFilters: {
      type: String,
      required: true,
    },
  },

  computed: {
    mergedLabels() {
      return _.merge({}, labels$1, _.get(this, '$props.labels'));
    },
    muiAlgoliaAutocompleteProps() {
      return {
        title: result => result.email,
        label: this.mergedLabels.selectLabel,
        placeholder: this.mergedLabels.selectPlaceholder,
        index: this.$props.algoliaIndex,
        filters: this.$props.algoliaFilters,
        disabled: this.$props.disabled,
        name: 'additionalDriversComponent',
        objectValue: 'email',
        optionalText: '',
        class: this.mergedLabels.customError ? 'mb-0' : 'mb-2',
        validation: false,
        fullWidth: true,
      };
    },
  },

  created() {
    this.EVENTS = COMPONENT_EVENTS;
  },

  methods: {
    onSelectOption(email) {
      const text = this.cleanText(email);

      if (text) {
        this.emitChange(text);
        this.removeSelectedOption(this.getSelectComponent());
      }
    },

    getSelectComponent() {
      return _.get(this, '$refs.muiAlgoliaAutocomplete.$refs.autocomplete.$refs.selector');
    },

    cleanText(value) {
      const text = _.isString(value) ? _.trim(value) : null;

      return _.isEmpty(text) ? null : text;
    },

    emitChange(value) {
      this.$emit(this.EVENTS.change, value);
    },

    removeSelectedOption(component) {
      if (!_.isObject(component)) {
        return;
      }

      const selectComponent = component;
      selectComponent.selected = null;
    },
  },
};

const getAlgoliaFilterExcludingValues = (field, data = []) => {
  const isFieldParamValid = _.isString(field) && !_.isEmpty(field);
  const isDataParamValid = _.isArray(data) && data.every(item => _.isString(item));

  if (!(isFieldParamValid && isDataParamValid)) {
    return null;
  }

  const filter = _.map(data, item => `${field}:'${item}'`).join(' AND NOT ');

  return filter ? `NOT ${filter}` : null;
};

var algoliaHelpers = /*#__PURE__*/Object.freeze({
  getAlgoliaFilterExcludingValues: getAlgoliaFilterExcludingValues
});

export { AdditionalDriversComponent, AdditionalPassengersComponent, COMPONENT_EVENTS, COST_ALLOCATION_INPUT_TYPE, costAllocationType as COST_ALLOCATION_TYPE, CostAllocationDataModule, CostAllocationFormComponent, INITIAL_STATUS, PROFILES, PreferredLocationsComponent, PreferredLocationsModule, UserBadgeComponent, VEHICLE_USER_ID, VEHICLE_USER_TYPES, VehicleUserModule, algoliaHelpers };
